module.exports = __webpack_public_path__ + "static/media/United-Way-logo.6581569f.png";